import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";

import { Metadata, Content } from "../../util/types";

export interface Contact {
    metadata: Metadata;
    star: boolean;
    first_name: string;
    last_name: string | null;
    nickname: string | null;
    birthday: string | null;
    phone_priv1: string | null;
    phone_priv2: string | null;
    phone_pro1: string | null;
    phone_pro2: string | null;
    address1: string | null;
    address2: string | null;
    email_priv1: string | null;
    email_priv2: string | null;
    email_pro1: string | null;
    email_pro2: string | null;
    tag: string | null;
    profile_image: string | null;
    content: Content;
}

export interface ContactEditRequest {
    id: string | null;
    star: boolean;
    first_name: string;
    last_name: string;
    nickname: string | null;
    birthday: string | null;
    phone_priv1: string | null;
    phone_priv2: string | null;
    phone_pro1: string | null;
    phone_pro2: string | null;
    address1: string | null;
    address2: string | null;
    email_priv1: string | null;
    email_priv2: string | null;
    email_pro1: string | null;
    email_pro2: string | null;
    tag: string | null;
    profile_image: string | null;
    content: string;
}

export interface ContactResponse {
    contact: Contact | null;
    contacts: { [key: string]: Contact };
    errors: string[];
}

/*
export interface TicketItemsResponse {
    tickets: { [key: string]: Ticket };
    ticket_items: { [key: string]: TicketItem };
    errors: string[];
}
// */

export interface ContactState {
    store: { [key: string]: Contact };
}

const initialState: ContactState = {
    store: {},
};

export const contactSlice = createSlice({
    name: "contact",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        upsertContact: (state, action: PayloadAction<Contact>) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            const id = action.payload.metadata.id;
            if (id) {
                state.store[id] = action.payload;
                return state;
            } else {
                return state;
            }
        },
        upsertContacts: (
            state,
            action: PayloadAction<{ [key: string]: Contact }>,
        ) => {
            state.store = { ...state.store, ...action.payload };
        },
    },
});

export const { upsertContact, upsertContacts } = contactSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCount = (state: RootState) => state.counter.value;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export default contactSlice.reducer;
